import { Box, Paper, Typography } from '@mui/material'
import {
  UI_COLOR_BORDER_CARD,
  UI_COLOR_TEXT_HEADING,
  UI_COLOR_TEXT_TITLE_ALT
} from '../constants/uiColors'
import { formatMoney } from '../helpers/utils'

export default function PaymentMethodsSummary({ methods = [] }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))',
          lg: 'repeat(7, minmax(0, 1fr))'
        },
        gap: 1.5
      }}
    >
      {methods.map((method) => (
        <Paper
          key={method.key}
          elevation={0}
          sx={{
            border: `1px solid ${UI_COLOR_BORDER_CARD}`,
            borderRadius: 1,
            px: 1.5,
            py: 1.5,
            minHeight: 78,
            display: 'flex',
            alignItems: 'flex-start'
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                color: UI_COLOR_TEXT_TITLE_ALT,
                fontSize: 12,
                fontWeight: 700,
                textTransform: 'uppercase',
                lineHeight: 1.2,
                mb: 1
              }}
            >
              {method.label}:
            </Typography>
            <Typography
              sx={{ color: UI_COLOR_TEXT_HEADING, fontSize: 17, fontWeight: 800, lineHeight: 1.2 }}
            >
              {formatMoney(method.amount || 0)}
            </Typography>
          </Box>
        </Paper>
      ))}
    </Box>
  )
}
